import axios from "axios";

const Api = axios.create({
    baseURL: process.env.REACT_APP_URL_API // 'https://runtimesistemas.com.br/api/'
    //crossdomain: true,
    //headers: { 'Access-Control-Allow-Origin':'*' }
})

export default Api;